module.exports = __webpack_public_path__ + "static/media/ecVideo7.cf6a0fa3.mp4";